import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/ramlab.webp';
import screenshot_target from '../../../images/letterfunnel/weiya.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Wei Ya"
      firstname="Wei"
      companyname="RAMLAB"
      competition="MX3D en WAAM3D"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/weiya.js